import React from 'react';

import styles from './DividerBlock.module.scss';

const DividerBlock = ({ className }: { className: any }) => (
  <div className={className}>
    <div className={styles.divider} />
  </div>
);

export default React.memo(DividerBlock) as any;
